var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('LoadingCard'):_c('div',[_c('CreateBaseFertiliserApplication',{attrs:{"userId":_vm.userId,"logId":_vm.logId,"cropTypeId":_vm.cropTypeId,"blocks":_vm.availableBlocks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }